import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { PERSISTED_LOGIN_ID } from './ids';
import { formShape } from 'rc-form';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import Collapse from '@material-ui/core/Collapse';
import { colors } from '../../../constants/colors';
import { analyticsTrackEvent } from '../../../core/analytics';
import { SIGN_UP_KEEP_ME_LOGGED_IN } from '../../../core/analytics/events';
import { fontSize, fontFamily } from '../../../constants/text';
import { isNativeApp } from '../../../core/util/device';
import { isClientSide } from '../../../core/util/system';

const Root = styled.div`
  margin-top: 10px;
  letter-spacing: 0.04px;
`;

const CheckboxContainer = styled(FormControlLabel)`
  > span {
    font-size: ${fontSize.default};
    color: ${props => (props.checked ? colors.blueLoadingScreen : colors.iThoughtWeHadAllTheGreys)};
    line-height: 24px;
  }
`;

const WarningContainer = styled.div`
  font-size: ${fontSize.default};
  font-family: ${fontFamily.book};
  color: ${colors.lightText};
  margin-bottom: 10px;
`;

function isPrivateDevice() {
  return isNativeApp() && isClientSide() && window.isPrivateDevice;
}

export default class PersistedLoginInput extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    form: formShape.isRequired,
  };

  state = {
    checked: isPrivateDevice(),
    isWarningDialogOpen: false,
  };

  componentDidMount = () => {
    const { setFieldsValue } = this.props.form;
    setFieldsValue({ [PERSISTED_LOGIN_ID]: this.state.checked });
  };

  getInputProps = () => {
    const { getFieldValue, getFieldProps } = this.props.form;

    return {
      ...getFieldProps(PERSISTED_LOGIN_ID),
      id: PERSISTED_LOGIN_ID,
      value: getFieldValue(PERSISTED_LOGIN_ID) || false,
      type: 'checkbox',
    };
  };

  openDialog = () => {
    this.setState({ checked: true, isWarningDialogOpen: true });
    analyticsTrackEvent(SIGN_UP_KEEP_ME_LOGGED_IN, {
      action: 'open dialog',
    });
  };

  handleClick = () => {
    const { checked } = this.state;
    analyticsTrackEvent(SIGN_UP_KEEP_ME_LOGGED_IN, {
      action: checked ? 'uncheck' : 'check',
    });
    if (checked) {
      this.setState({ checked: false, isWarningDialogOpen: false });
    } else {
      this.openDialog();
    }
  };

  render = () => {
    const { className } = this.props;
    const { checked, isWarningDialogOpen } = this.state;

    return (
      <Root>
        <CheckboxContainer
          className={className}
          control={
            <Switch checked={checked} onClick={this.handleClick} {...this.getInputProps()} />
          }
          checked={checked}
          label="Keep me logged in"
        />
        {!isPrivateDevice() && (
          <Collapse in={isWarningDialogOpen} timeout="auto">
            <WarningContainer>
              If this is a shared or public device, we do not recommend using this option.
            </WarningContainer>
          </Collapse>
        )}
      </Root>
    );
  };
}
